import { Button } from "@mui/material";
import React from "react";

const CustomButton = ({
  text,
  baseColor,
  hoverColor,
  onClick,
  isFullWidth = true,
  width,
  icon,
  disabled = false
}) => {
  return (
    <div>
      <Button
        variant="contained"
        onClick={onClick}
        disabled={disabled}
        sx={{
          backgroundColor: baseColor,
          padding: "10px",
          fontSize: { xs: "12px", sm: "15px" },
          textTransform: "capitalize",
          fontWeight: "600",
          "&:hover": {
            backgroundColor: hoverColor,
            color: "#ffffff",
          },
          width: {width}
        }}
        fullWidth={isFullWidth}
        startIcon={icon}
      >
        {text}
      </Button>
    </div>
  );
};

export default CustomButton;
